//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.ParamBuilder.js";
import "../CAM/CAM.PostEventsCiBuilder.js";
import "../CAM/CAM.UdeSet.js";
import "../CAM/CAM.GeometryCiBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.LayoutCiBuilder.js";
import "../CAM/CAM.ArcOutputTypeCiBuilder.js";
import "../CAM/CAM.Notes.js";
import "../CAM/CAM.OperationDisplayOptionsBuilder.js";
import "../CAM/CAM.ToolChangeCiBuilder.js";
import "../CAM/CAM.ToolPathSplitParametersBuilder.js";
let d=[[[0,"ChannelName",1,0],[0,"Description",1,0],[1,"EndOfPath",0,"CAM.PostEventsCiBuilder",0],[1,"EndUdeSet",0,"CAM.UdeSet",0],[1,"Geometry",0,"CAM.GeometryCiBuilder",0],[0,"GougeChecking",1,0],[0,"HoleAxisType",1,0],[1,"HoleDepth",0,"CAM.InheritableDoubleBuilder",0],[0,"HoleDepthType",1,0],[1,"LayoutAndLayer",0,"CAM.LayoutCiBuilder",0],[1,"MotionOutputBuilder",0,"CAM.ArcOutputTypeCiBuilder",0],[1,"Notes",0,"CAM.Notes",0],[0,"OptimizationBasedOn",1,0],[0,"OptimizationDistanceMethod",1,0],[0,"OptimizationLevel",1,0],[1,"PathDisplayOptions",0,"CAM.OperationDisplayOptionsBuilder",0],[0,"PostToolPathExit",1,0],[1,"RetractDistance",0,"CAM.InheritableDoubleBuilder",0],[1,"RetractDistanceOnToolAxisChange",0,"CAM.InheritableDoubleBuilder",0],[1,"SafeClearance",0,"CAM.InheritableDoubleBuilder",0],[0,"SelectToolFlag",1,0],[1,"StartOfPath",0,"CAM.PostEventsCiBuilder",0],[1,"StartUdeSet",0,"CAM.UdeSet",0],[1,"ToolChangeSetting",0,"CAM.ToolChangeCiBuilder",0],[0,"ToolPathEditor",0,"CAM.ToolPathEditorBuilder",0],[1,"ToolPathSplitParametersBuilder",0,"CAM.ToolPathSplitParametersBuilder",0]],[[["count"],"GetHoleAxisValues",{R_:{holeAxis:""}},0,0],[["holeAxis"],"SetHoleAxisValues",{},1,0]],[]];
SPLM.CAM.OperationBuilder = class extends SPLM.CAM.ParamBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.OperationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.OperationBuilder.HoleAxisTypes = Object.freeze({
    "Vector" : "Vector", "Rule" : "Rule", "RuleIfNoVector" : "RuleIfNoVector"});

SPLM.CAM.OperationBuilder.HoleDepthTypes = Object.freeze({
    "Point" : "Point", "Rule" : "Rule"});

SPLM.CAM.OperationBuilder.OptimizationLevelTypes = Object.freeze({
    "Standard" : "Standard", "Advanced" : "Advanced"});

SPLM.CAM.OperationBuilder.OptimizationBasedOnTypes = Object.freeze({
    "Dist" : "Dist", "Orient" : "Orient"});

SPLM.CAM.OperationBuilder.OptimizationDistanceTypes = Object.freeze({
    "Direct" : "Direct", "Transition" : "Transition"});

export default SPLM;